import "regenerator-runtime/runtime";
import axios from "axios";

let weather = {
  Lausanne: {
    day: "Monday",
    temp: 21,
  },
  Paris: {
    day: "Tuesday",
    temp: 12,
  },
  Sidney: {
    day: "Wednesday",
    temp: 20,
  },
  NewYork: {
    day: "Thursday",
    temp: 12,
  },
  Tokyo: {
    day: "Friday",
    temp: 14,
  },
  Torento: {
    day: "Saturday",
    temp: 30,
  },
  Rome: {
    day: "Sunday",
    temp: 10,
  },
};

let days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday ",
  "Thursday",
  "Friday",
  "Saturday",
];

let months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

let currentDate = new Date();
let day = currentDate.getDay();
let daysD = days[day];
let hour = currentDate.getHours();
let month = currentDate.getMonth();
let monthsD = months[month];
let year = currentDate.getFullYear();
let minute = currentDate.getMinutes();
let cityDay = document.querySelector(".city-day");
cityDay.innerHTML = `${daysD} ${monthsD} ${year}<br />${hour}:${minute}`;

//const axios = require("axios").default;

function showFarLink(event) {
  event.preventDefault();
  celsLink.classList.remove("active");
  farLink.classList.add("active");
  let farenhaitTemp = (celsusTemp * 9) / 5 + 32;
  let temperature = document.querySelector(".temp");
  temperature.innerHTML = Math.round(farenhaitTemp);
}

function showCelsLink(event) {
  event.preventDefault();
  celsLink.classList.add("active");
  farLink.classList.remove("active");
  let farenhaitTemp = (celsusTemp * 9) / 5 + 32;
  let temperature = document.querySelector(".temp");
  temperature.innerHTML = Math.round(celsusTemp);
}

let farLink = document.querySelector(".farLink");
farLink.addEventListener("click", showFarLink);

let celsLink = document.querySelector(".celsLink");
celsLink.addEventListener("click", showCelsLink);

function showWeatherCondition(response) {
  celsusTemp = response.data.main.temp;
  let temperature = Math.round(celsusTemp);
  let cardTemp = document.querySelector(".temp");
  cardTemp.innerHTML = temperature;

  document.querySelector(".city").innerHTML = response.data.name;
  //let classCity = document.querySelector(".city");
  //classCity.innerHTML = city;

  let wind = document.querySelector(".wind_speed");
  wind.innerHTML = response.data.wind.speed;
  let descrip = document.querySelector(".w_description");
  descrip.innerHTML = response.data.weather[0].description;
  let humidity = document.querySelector(".humidity");
  humidity.innerHTML = response.data.main.humidity;

  // weather icon
  let icon = response.data.weather.icon;
  let emoji_1 = document.querySelector(".emoji-1");
  emoji_1.setAttribute(
    "src",
    `http://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`
  );
  emoji_1.setAttribute("alt", response.data.weather[0].description);
}

//forecast

function formatDay(timestamp) {
  let date = new Date(timestamp * 1000);
  let day = date.getDay();

  let days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Sarturday",
  ];

  return days[day];
}

function displayForecast(response) {
  let forecast = response.data.daily;
  console.log(response.data.daily);
  let daysForecast = document.querySelector("#day_daily");
  let forecastHtml = `<div class="row" id="card">`;
  forecast.forEach((foreDay, index) => {
    if (index < 6) {
      forecastHtml =
        forecastHtml +
        `<div class="col" id="col">
    <div class="card" style="width: 10rem;">
      <div class="card-body">
        <h5 class="card-title" id="day_daily">${formatDay(foreDay.dt)}</h5>
        <img src="http://openweathermap.org/img/wn/${
          foreDay.weather[0].icon
        }@2x.png" lass="emoji-2" 
        "alt",
        width="42"/>
        <p class="card-text">
          <span>${Math.round(foreDay.temp.max)}°</span>
      
          <span>${Math.round(foreDay.temp.min)}°</span>
        </p>
       
      </div>
      
    </div>
  </div>`;
    }
  });

  daysForecast.innerHTML = forecastHtml;
}

function forecastWeather(coords) {
  let apiKey = "f730e91b30cbe17d7d77b0e941835ced";
  let lat = 33;
  let lon = 12;
  let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${lat}&lon=${lon}&appid=${apiKey}&units=metric`;
  console.log(apiUrl);
  axios.get(`${apiUrl}&appid=${apiKey}`).then(displayForecast);
}

function search(e) {
  //console.log(response.data);
  e.preventDefault();
  let apiKey = "f730e91b30cbe17d7d77b0e941835ced";
  let city = document.querySelector("#input_form").value;
  //let city = "paris";
  let units = "metric";
  let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&units=${units}`;
  console.log(apiUrl);
  axios.get(`${apiUrl}&appid=${apiKey}`).then(showWeatherCondition);

  forecastWeather();
}

let celsusTemp = null;

let btn = document.querySelector(".d-flex");
btn.addEventListener("submit", search);

//function showPosition(position) {
//let h1 = document.querySelector("h1");
// h1.innerHTML = `Your latitude is ${position.coords.latitude} and xour longitude is ${position.coords.longitude}`;
//}

//function getCurrentPosition() {
//// navigator.geolocation.getCurrentPosition(showPosition);
//}

//let btn = document.querySelector("button");
//btn.addEventListener("click", getCurrentPosition);
